import { applyTokens } from "../../../utilities/applyTokens.js";
const avatarGroupTheme = (tokens) => {
    const { avatarGroup } = tokens.component;
    const { avatar, additionalAvatar } = avatarGroup;
    return {
        MuiAvatarGroup: {
            styleOverrides: {
                root: {
                    flexDirection: "row",
                    "& .MuiAvatar-root": Object.assign(Object.assign({}, applyTokens(avatar)), { boxSizing: "border-box", "&:last-of-type": {
                            marginLeft: "-4px",
                        } }),
                },
                avatar: Object.assign(Object.assign({}, applyTokens(additionalAvatar)), { "&.MuiAvatar-colorDefault": {
                        order: 1,
                        zIndex: 1,
                    } }),
            },
        },
    };
};
export default avatarGroupTheme;
//# sourceMappingURL=avatarGroup.js.map